export const name = 'assetsLibService';
export default function assetsLibService($http, $q, $log, templatesService) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let composerAssetsManagementUrl = "/api/composer-service/v1/composer/assets";

  return {
    uploadFile: uploadFile,
    getAssetLibsByPage: getAssetLibsByPage,
    getAssetLibsByUUIDs: getAssetLibsByUUIDs,
    deleteAssetLibraries: deleteAssetLibraries
  };

  function getAssetLibsByPage(page, pageSize, filter, tag, isInitializing, isLoadingRequired = true){
      let functionName = 'assetsLibService.getAssetLibsByPage';
      $log.info(angular.toJson({functionName: functionName, action: 'functionName called', page:page, pageSize:pageSize, filter:filter, isInitializing:isInitializing}));

      let url = composerAssetsManagementUrl + '/page';

      return $http({
        method: 'GET',
        url: url,
        params: {
          'page': page,
          'page-size': pageSize,
          'search-filter': filter,
          'is-initializing': isInitializing
        },
        headers: {'Accept':'application/json'}})
          .then(function (assetLibCollection) {
            return assetLibCollection.data;
      }, error => {
        $log.error(angular.toJson({functionName: functionName, action: 'getAssetLibsByPage return with error', error:error.data}));
      });
  }

  function getAssetLibsByUUIDs(assetLibsUUIDs){
      let functionName = 'assetsLibService.getAssetLibsByUUIDs';
      $log.info(angular.toJson({functionName: functionName, action: 'functionName called', assetLibsUUIDs:assetLibsUUIDs}));

      let url = composerAssetsManagementUrl + '/';

      return $http({
        method: 'GET',
        url: url,
        params: {
          'assetLibsUUIDs': assetLibsUUIDs,
        },
        headers: {'Accept':'application/json'}})
          .then(function (assetLibCollection) {
            return assetLibCollection.data;
      }, error => {
        $log.error(angular.toJson({functionName: functionName, action: 'getAssetLibsByUUIDs return with error', error:error.data}));
      });
  }

  function uploadFile(file, uploadProgressCallback, uploadController, mimeType, isConstant = true){
    let functionName = 'assetsLibService.uploadFile';
    $log.info(angular.toJson({functionName: functionName, action: 'functionName called', filename:file.name}));

    let defer = $q.defer();

    createEmptyFileEntry(file, isConstant).then(
      function (response) {
        $log.info(angular.toJson({
          functionName: functionName,
          action: 'createEmptyFileEntry completed successfully',
          storageAssetInfo: response
        }));

        let uploadIdentity = {
          assetLibName: "Asset library",
          assetLibUUID: response.assetsLibUUID,
        };
        uploadProgressCallback(null, response.assetsLibUUID);
        let percentageReportInterval = 1;
        templatesService.uploadFileToStorageService(uploadIdentity, file, response.storageId, percentageReportInterval, uploadProgressCallback, uploadController).then(
          function (storageAssetMetadata) {
            $log.info(angular.toJson({
              functionName: functionName,
              action: 'uploadFileToEntry completed successfully',
              storageAssetMetadata: storageAssetMetadata.data
            }));
            updateCompletionStatus(response.assetsLibUUID, isConstant).then(assetLib => {
              defer.resolve(assetLib);
            });
          }, function (error) {
            $log.error(angular.toJson({
              functionName: functionName,
              action: 'uploadFileToStorageService return with error',
              error: error
            }));
            defer.reject(error);
          }
        );
      },
      function (error) {
        $log.error(angular.toJson({
          functionName: functionName,
          action: 'createEmptyFileEntry return with error',
          error: error.data
        }));
        defer.reject(error.data);
      }
    );

    return defer.promise;
  }

  function createEmptyFileEntry(file, isConstant){
    let functionName = 'assetsLibService.createEmptyFileEntry';
    $log.info(angular.toJson({functionName: functionName, action: 'functionName called',filename:file.name}));
    let defer = $q.defer();

    let url = composerAssetsManagementUrl;

    let assetEntryCreationRequest = {
      assetLibName:file.name.substr(0, file.name.lastIndexOf('.')),
      constant: isConstant
    };

    $http({method: 'POST', url: url, data: assetEntryCreationRequest, headers: {'Accept':'application/json'}}).
    then(function(response){
      $log.log(angular.toJson({functionName:functionName, action:'function return with success', storageAssetInfo:response.data}));
      defer.resolve(response.data);
    },function(error) {
      $log.error(angular.toJson({functionName:functionName, action:'function return error',error:error.data, status:error.status}));
      defer.reject(error.status);
    });

    return defer.promise;
  }

  function updateCompletionStatus(assetLibUUID, isConstant){
    let functionName = 'assetsLibService.updateCompletionStatus';
    $log.info(angular.toJson({functionName: functionName, action: 'functionName called',assetLibUUID: assetLibUUID}));

    let defer = $q.defer();

    let url = composerAssetsManagementUrl + "/" + assetLibUUID;

    let clientTimestampInMilliseconds = (new Date()).getTime() - (new Date()).getTimezoneOffset()*60*1000;

    let uploadCompletionStatus ={
      success: true,
      clientTimestampInMilliseconds: clientTimestampInMilliseconds,
      constant: isConstant
    };

    $http({method: 'POST', url: url, data: uploadCompletionStatus, headers: {'Accept':'application/json'}}).
    then(function(response){
      $log.log(angular.toJson({functionName:functionName, action:'function return with success', template: response.data}));
      defer.resolve(response.data);
    },function(error) {
      $log.error(angular.toJson({functionName:functionName, action:'function return error',error:error.data, status:error.status}));
      defer.reject(error.status);
    });

    return defer.promise;
  }

  function deleteAssetLibraries(assetLibUUIDs){
    let functionName = 'assetsLibService.deleteAssetLibraries';
    $log.info(angular.toJson({functionName: functionName, action: 'functionName called',assetLibIds: assetLibUUIDs}));

    let url = composerAssetsManagementUrl;
    return $http({method: 'DELETE', url: url, data: assetLibUUIDs, headers: {'Content-Type':'application/json'}}).
    then(function(response){
      console.log(response);
    });

  }
}
